exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td,.table thead th{border:1px solid #000}", ""]);

// exports
